import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { useDroppable } from '@dnd-kit/core';
import type { Item } from '@mas-flow/types';
import { ItemCard } from './ItemCard';

export function KanbanColumn({ id, title, items }: { id: string; title: string; items: Item[] }) {
  const { setNodeRef } = useDroppable({ id });
  return (
    <section ref={setNodeRef} className="flex w-72 flex-col gap-2 rounded bg-slate-50 p-3" data-column={id}>
      <h2 className="text-xs font-semibold uppercase tracking-wide text-slate-600">
        {title} <span className="text-slate-400">({items.length})</span>
      </h2>
      <SortableContext id={id} items={items.map((i) => i.id)} strategy={verticalListSortingStrategy}>
        {items.length === 0 ? (
          <p className="text-xs italic text-slate-400">No items in {title}</p>
        ) : (
          items.map((it) => <ItemCard key={it.id} item={it} />)
        )}
      </SortableContext>
    </section>
  );
}
